<template>
    <div id="vehicleDataList">
        <div class="con">
            <img class="imgborder" src="../../assets/vehicleData/border.png" alt="">
            <div class="details">
                <div class="close" @click="close">
                    <img src="../../assets/vehicleData/close.png" alt="">
                </div>
                <div class="title">
                    <img src="../../assets/vehicleData/left.png" alt="">
                    <span class="text">农机数据</span>
                    <img src="../../assets/vehicleData/right.png" alt="">
                </div>
                <div class="line"><img src="../../assets/vehicleData/line.png" alt=""></div>
                <div class="content">
                    <div class="content_left">
                        <div class="search">
                            <el-input v-model="simId" placeholder="主机id或车牌号" clearable
                            >
                                <i slot="suffix" class="el-input__icon el-icon-search" @click="handleIconClick">

                                </i>
                            </el-input>
                        </div>
                        <div class="tree-container" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="transparent">
                            <el-tree class="tree" ref="tree" :data="treeList" :props="defaultProps" accordion @node-click="nodeclick" node-key="name" :default-expanded-keys="treeExpandData" :default-checked-keys="treeCheckedData" :filter-node-method="filterNode" >
                            </el-tree>
                        </div>
                    </div>
                    <div class="content_right">
                        <img class="bg" src="../../assets/vehicleData/bg.png" alt="">
                        <div class="right_list">
                            <div class="item">
                                <img @click="vehicleNodeClick(1)" v-if="tractorShow==false"  src="../../assets/vehicleData/tractor.png" alt="">
                                <img @click="vehicleNodeClick(1)" v-if="tractorShow==true" src="../../assets/vehicleData/tractorActive.png" alt="">
                                <div class="text1">{{tractorCount}}</div>
                                <div class="text2">拖拉机数量</div>
                            </div>
                            <div class="item">
                                <img @click="vehicleNodeClick(2)" v-if="harvesterShow==false" src="../../assets/vehicleData/harvester.png" alt="">
                                <img @click="vehicleNodeClick(2)" v-if="harvesterShow==true" src="../../assets/vehicleData/harvesterActive.png" alt="">
                                <div class="text1">{{harvesterCount}}</div>
                                <div class="text2">收获机数量</div>
                            </div>
                            <div class="item">
                                <img @click="vehicleNodeClick(3)" v-if="selfPropelledShow==false" src="../../assets/vehicleData/selfPropelled.png" alt="">
                                <img @click="vehicleNodeClick(3)" v-if="selfPropelledShow==true" src="../../assets/vehicleData/selfPropelledActive.png" alt="">
                                <div class="text1">{{plantProtectionMachineCount}}</div>
                                <div class="text2">植保机数量</div>
                            </div>
                            <div class="item" v-if="userName!='huaian_admin'">
                                <img @click="vehicleNodeClick(4)" v-if="towerShow==false" src="../../assets/vehicleData/tower.png" alt="">
                                <img @click="vehicleNodeClick(4)" v-if="towerShow==true" src="../../assets/vehicleData/towerActive.png" alt="">
                                <div class="text1">{{dryingTowerCount}}</div>
                                <div class="text2">烘干塔数量</div>
                            </div>
                            <div class="item">
                                <img @click="vehicleNodeClick(15)" v-if="chayangjiShow==false" src="../../assets/vehicleData/chayangji.png" alt="">
                                <img @click="vehicleNodeClick(15)" v-if="chayangjiShow==true" src="../../assets/vehicleData/chayangjiActive.png" alt="">
                                <div class="text1">{{transplanterCount}}</div>
                                <div class="text2">插秧机数量</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import {map} from '../../js/map.js';
import eventBus from '@/eventBus.js';
import WitVehicleStatisticsService from '../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.WitVehicleStatisticsService.js';
export default {
    data(){
        return{
            simId:"",
            dryingTowerCount: 0,
            harvesterCount: 0,
            plantProtectionMachineCount: 0,
            tractorCount: 0,
            transplanterCount: 0,
            treeList:[],
            provincialCenterId:"",
            treeExpandData:[],
            treeCheckedData:[],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            tractorShow:false,
            harvesterShow:false,
            selfPropelledShow:false,
            towerShow:false,
            chayangjiShow:false,
            userName:localStorage.getItem("userName")
        }
    },
    mounted(){
        var that = this
        that.onload();
        that.forVehicleTypeCount();
        that.forVehicleList()
    },
    watch: {
        simId(val) {
            this.$refs.tree.filter(val);
        },
    },
    methods:{
        onload(){
            var that = this
            eventBus.$on('vehicleListSuccess',function () {
                that.forVehicleList()
            })
        },
        // 车辆树
        forVehicleList(){
            var that=this
            var vehicleList=JSON.parse(JSON.stringify(that.$store.state.vehicleList))
            var depList=JSON.parse(JSON.stringify(that.$store.state.departmentList))
            var depMap=new Map();
            depList.forEach(item => {
                depMap.set(item.entityId,item)
            })
            for(var a=0;a<vehicleList.length;a++){
                if(vehicleList[a].online==true){
                    that.onlineNum+=1//在线车辆
                    that.$store.state.onlineNum+=1//在线车辆
                    if(vehicleList[a].status&&vehicleList[a].alarmState){
                        var status=vehicleList[a].alarmState+vehicleList[a].status
                        // 车辆报警状态
                        var snumber=63
                        if( !isNaN(status) ){
                            if(vehicleList[a].haveCamera==1){
                                if( status.substr((snumber - 1),1)==0 || vehicleList[a].simIdPlough=='000000000000' || vehicleList[a].simIdPlough=='000000111111' || status.substr((snumber - 43),1)==1){
                                    vehicleList[a].isAlarm=true
                                    that.alarmNum+=1//报警车辆
                                    that.$store.state.alarmNum+=1
                                }else{
                                    vehicleList[a].isAlarm=false
                                }
                            }else if(vehicleList[a].haveCamera==0){
                                if( status.substr((snumber - 1),1)==0 || vehicleList[a].simIdPlough=='000000000000' || vehicleList[a].simIdPlough=='000000111111'){
                                    vehicleList[a].isAlarm=true
                                    that.alarmNum+=1//报警车辆
                                    that.$store.state.alarmNum+=1
                                }else{
                                    vehicleList[a].isAlarm=false
                                }
                            }
                        } 
                    }
                }
                vehicleList[a].name=vehicleList[a].plateNo
                var parentId=vehicleList[a].depId
                while(parentId&&parentId!=undefined){
                    var dep=depMap.get(parentId)
                    if(dep==undefined){
                        // console.log(parentId)
                        break;
                    }
                    var totalNum = dep.totalNum==undefined?0:dep.totalNum;
                    dep.totalNum=totalNum+1
                    var onlineNum =  dep.onlineNum==undefined?0:dep.onlineNum;
                    if(vehicleList[a].online){
                        dep.onlineNum=onlineNum+1
                        dep.online=true
                    }
                    var alarmNum = dep.alarmNum==undefined?0:dep.alarmNum;
                    if(vehicleList[a].isAlarm){
                        dep.alarmNum=alarmNum+1
                        dep.isAlarm=true
                    }
                    parentId=dep.parentId
                }
                // 全部车辆
                that.totalNum+=1
                that.$store.state.totalNum+=1
            }
            var list=[];
            for(var j=0;j<depList.length;j++){
                var children=[];
                var deps=depMap.get(depList[j].entityId)
                depList[j].name=depList[j].name+"("+deps.onlineNum+"/"+deps.totalNum+")"
                for(var i=0;i<vehicleList.length;i++){
                    if(vehicleList[i].depId==depList[j].entityId){
                        if(vehicleList[i].online){//在线车辆开头添加，不在线车辆结尾添加
                            children.unshift(vehicleList[i])
                        }else{
                            children.push(vehicleList[i])
                        }
                    }
                }
                depList[j].children=children
                if(deps.totalNum>0){
                    list.push(depList[j])
                }
            }
            var treeData=[]
            if(list.length>1){
                treeData=that.filterArray(list)
            }else{
                treeData=list
            }
            that.treeList=treeData
        },
        filterArray(data, parent) {
            var id;
            if(localStorage.getItem('layer')=='admin'){
                id='0'
            }else if(localStorage.getItem('layer')=='省'){
                id=localStorage.getItem('provinceId')
            }else if(localStorage.getItem('layer')=='市'){
                id=localStorage.getItem('cityId')
            }else if(localStorage.getItem('layer')=='县'){
                id=localStorage.getItem('areaId')
            }
            var par = parent == undefined ? id : parent
            var tree = [];
            var temp;
            for (var i = 0; i < data.length; i++) {
                if (data[i].parentId == par) {
                    var obj = data[i];
                    temp = this.filterArray(data, data[i].entityId);
                    if (temp.length > 0) {
                        obj.children = temp;
                    }
                    tree.push(obj);
                }
            }
            return tree;
        },
        filterNode(value, data) {
            if(data.simNo){
                if(!this.simId){
                    return true;
                }else if(this.simId){
                    return data.simNo.indexOf(this.simId) !== -1 || data.name.indexOf(this.simId) !== -1
                }
            }
        },
        // 获取树形结构默认展开节点
        getRoleTreeRootNode(provincialCenterId) {
            this.treeExpandData.push(provincialCenterId)   
        },
        // 树形控件节点选中事件
        nodeclick(data){
            var that = this
            if(data.vehicleId){//
                if(that.$store.state.details==''){
                    that.$store.state.details='vehicleDataDetails'
                    that.$store.state.camera=''
                }else{
                    that.$store.state.details='vehicleDataDetails'
                    that.$store.state.camera=''
                }
                that.$store.state.vehicleDataDialog=false
                that.tractorShow=false
                that.harvesterShow=false
                that.selfPropelledShow=false
                that.towerShow=false
                if(data.lng==''||data.lng==null||data.lng==undefined||data.lat==''||data.lat==null||data.lat==undefined){
                    that.$message({
                        message: '车辆不定位',
                        type: 'warning'
                    });
                }else{
                    map.mapCenterChange(that,data.lng,data.lat,17)
                }
                that.$nextTick(function () {
                    setTimeout(function(){
                        eventBus.$emit('check',data.vehicleId,1,data.vehicleType)//车辆id,
                    },500)
                })
            }
        },
        //查找各类型车辆的数量
        forVehicleTypeCount(){
            WitVehicleStatisticsService.findVehicleTypeCount()
            .then((res)=>{
                // console.log(res)
                this.dryingTowerCount=res.dryingTowerCount
                this.harvesterCount=res.harvesterCount
                this.plantProtectionMachineCount=res.plantProtectionMachineCount
                this.tractorCount=res.tractorCount
                this.transplanterCount=res.transplanterCount
            })
        },
        // 查车辆
        handleIconClick(){
            // console.log('查找车辆')
        },
    
        vehicleNodeClick(type){
            this.$store.state.vehicleDataDialog=true;
            this.$emit("checkVehicleNode",type)
        },
        // 点击关闭
        close(){
            this.$store.state.details=''
            this.$store.state.detailList=''
            this.$store.state.list='centerBot'
            this.$store.state.vehicleDataDialog=false;
        },
    },
    beforeDestroy() {
        $('#home_details').removeClass('home-details')
        eventBus.$off('vehicleListSuccess')
    }
}
</script>
<style lang="less">
@import '../../viewsStyle/vehicleData/vehicleDataList.less';

</style>